module.exports = __webpack_public_path__ + "static/media/iit-delhi-logo.50c5df3e.png";